import { createQueryStringToggleHook } from "../../../../../stores/useQueryState";

export const tireLoadRatingParamName = "load";

export const useTireLoadRating = createQueryStringToggleHook(
  tireLoadRatingParamName,
  []
);
